import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { animateToScreen } from '../../redux/ui/actions';
import {
  setCurrentZone,
  setTicketZones,
  setSeasonalTicketZones as setSeasonalTicketZonesAction,
} from '../../redux/cardReader/actions';
import { TICKET_TYPE_EXTRA_TICKET } from '../../constants';
import { getZoneButtonsComponent, getZoneBackgroundImage } from '../helpers';
import CardReaderScreen from '../../molecules/CardReaderScreen';

class ExtraTicketRegionRC extends PureComponent {
  onZoneClick = (zones) => {
    this.props.setSeasonalTicketZones(zones);
    this.props.setTicketZones(zones);
    this.props.goToPurchaseScreen();
  };

  render() {
    const { currentZone, previousScreen } = this.props;
    const ZoneButtonsComp = getZoneButtonsComponent(currentZone);
    const zoneImg = getZoneBackgroundImage(currentZone);
    const fadeDuration =
      previousScreen === 'ValueTicketRegion' ? '0ms' : '500ms';
    return (
      <CardReaderScreen backgroundImage={zoneImg} fadeDuration={fadeDuration}>
        <ZoneButtonsComp
          onClickZoneAB={() => this.onZoneClick('AB')}
          onClickZoneABC={() => this.onZoneClick('ABC')}
          onClickZoneABCD={() => this.onZoneClick('ABCD')}
          onClickZoneBCD={() => this.onZoneClick('BCD')}
          onClickZoneCD={() => this.onZoneClick('CD')}
          onClickZoneBC={() => this.onZoneClick('BC')}
          onClickZoneD={() => this.onZoneClick('D')}
          onClickUpButton={() => this.props.setCurrentZone(`${currentZone[0]}`)}
          onClickDownButton={() => this.props.setCurrentZone(`${currentZone}2`)}
        />
      </CardReaderScreen>
    );
  }
}
ExtraTicketRegionRC.propTypes = {
  goToPurchaseScreen: PropTypes.func.isRequired,
  setCurrentZone: PropTypes.func.isRequired,
  setSeasonalTicketZones: PropTypes.func.isRequired,
  setTicketZones: PropTypes.func.isRequired,
  previousScreen: PropTypes.string.isRequired,
  currentZone: PropTypes.string.isRequired,
};

const mapStateToProps = ({ ui, cardReader }) => ({
  previousScreen: ui.previousScreen,
  currentZone: cardReader.currentZone,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentZone: (zone) => dispatch(setCurrentZone(zone)),
  goToPurchaseScreen: () => dispatch(animateToScreen('ExtraTicketPurchase')),
  setSeasonalTicketZones: (zones) => dispatch(setSeasonalTicketZonesAction(TICKET_TYPE_EXTRA_TICKET, zones)), // eslint-disable-line
  setTicketZones: (zones) => dispatch(setTicketZones(TICKET_TYPE_EXTRA_TICKET, zones)),  // eslint-disable-line
});

// prettier-ignore
export default connect(mapStateToProps, mapDispatchToProps)(ExtraTicketRegionRC);
